import {useQuery} from '@tanstack/react-query';
import {useRequiredTenantId} from '@/matic/hooks/useRequiredTenantId';
import {getErpRecordProvenanceApi} from '../api/erp-record-provenance-api';
import {erpProvenanceKeys} from '../query-keys';
import type {ErpSyncedType} from '../types';

/**
 * Which ObjectTypes an ERP sync feeds, keyed by ObjectType id.
 *
 * Readable by every role — Master Data is, so a reader of a Parts table needs
 * to know it's ERP-fed and how current it is. Stale data that doesn't say
 * it's stale reads as wrong data.
 *
 * Sync configuration changes rarely, so the global 5-minute staleTime is
 * right; the timestamp it carries moves only when an admin runs a sync.
 */
export function useErpSyncedTypes() {
  const tenantId = useRequiredTenantId();
  const api = getErpRecordProvenanceApi();

  return useQuery<Map<string, ErpSyncedType>>({
    queryKey: erpProvenanceKeys.syncedTypes(tenantId),
    queryFn: async () => api.listSyncedTypes(),
  });
}
